/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_ParentInputs */

const en_tree_parent = /** @type {(inputs: Tree_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent`)
};

const de_tree_parent = /** @type {(inputs: Tree_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordnet`)
};

/**
* | output |
* | --- |
* | "Parent" |
*
* @param {Tree_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tree_parent = /** @type {((inputs?: Tree_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tree_parent(inputs)
	return en_tree_parent(inputs)
});